import { Col, Row } from 'antd';
import styled from 'styled-components';
import { boxShadow, maxWidth, retina } from 'Utils/utilsStyle';
import SinglePersonCardSkeleton from 'Components/common/skeleton/SinglePersonCardSkeleton';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

const Wrapper = styled.div`
  box-shadow: ${boxShadow};
  border-radius: 16px;
  background: #fff;
  padding: 40px 20px 40px 0px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 40px 20px 40px 0px;
  }
`;

const Wrapper1 = styled.div`
   padding: 0px 0px 0px 30px;
`;

const SriProfileSkeleton = function SriProfileSkeleton() {
  return (
    <Wrapper>
      <div className="sri-person-card">
        <Row className="align-item-center-100-res">
          <Col span={8}>
            <SinglePersonCardSkeleton />
          </Col>
          <Col span={16}>
            <Wrapper1>
              <Row gutter={[16, 16]}>
                <Col span={9}>
                  <SkeletonCustom height="348px" width="100%" diameter="12px" />
                </Col>
                <Col span={15}>
                  <Row gutter={[16, 16]}>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                    <Col span={8}>
                      <SkeletonCustom height="156px" width="100%" diameter="12px" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Wrapper1>
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default SriProfileSkeleton;
